export async function checkAppVersion(): Promise<boolean> {
  // Avoid checking in development environment
  if (process.env.NODE_ENV === "development") return false;

  try {
    const res = await fetch("/api/version", { cache: "no-store" });
    if (!res.ok) return false;
    
    const data = await res.json();
    const serverVersion = data.version;
    const clientVersion = process.env.NEXT_PUBLIC_APP_VERSION;

    if (serverVersion && clientVersion && serverVersion !== clientVersion) {
      return true;
    }
  } catch (error) {
    console.error("Failed to check version", error);
  }
  
  return false;
}
